import { useEffect } from 'react'
import { Button } from './button'
import { convert3DWebsite, restore2DWebsite } from '@/lib/website3d'

interface Website3DToggleProps {
  is3DMode: boolean
  setIs3DMode: (value: boolean) => void
  stopPropagation?: boolean
}

const Website3DToggle = ({ is3DMode, setIs3DMode, stopPropagation = false }: Website3DToggleProps) => {
  useEffect(() => {
    let cleanup: (() => void) | undefined

    if (is3DMode) {
      cleanup = convert3DWebsite()
    } else {
      restore2DWebsite()
    }

    return () => {
      if (cleanup) cleanup()
    }
  }, [is3DMode])

  const handleClick = (e: React.MouseEvent) => {
    if (stopPropagation) {
      e.stopPropagation()
    }
    setIs3DMode(!is3DMode)
  }

  return (
    <Button
      onClick={handleClick}
      variant="outline"
      className="mt-4 text-foreground border-foreground/20 hover:bg-foreground/5"
      aria-label={is3DMode ? 'Disable 3D View' : 'Enable 3D View'}
    >
      {is3DMode ? 'Disable 3D' : 'Enable 3D'}
    </Button>
  )
}

export default Website3DToggle 